<template>
  <div class="chainDecrypt-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      :rules="editRules"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="加密方式" prop="cipher_text">
            <el-select
              v-model="formDate.method"
              placeholder="请选择"
              class="auto-width"
              @change="methodChange"
            >
              <el-option
                v-for="ele in options"
                :key="parseInt(ele.value)"
                :label="ele.label"
                :value="parseInt(ele.value)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="私钥" prop="pri_key">
            <el-input v-model="formDate.pri_key" placeholder="请输入私钥"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="加密结果">
            <el-input
              v-model="proclaimedTextEncryption"
              class="excellent-form-input readonly-text"
              readonly=""
              type="textarea"
              autosize=""
              disabled
            ></el-input>
            <el-button v-if="isChangeText" class="excellent-form-btn" @click.prevent="changeText()"
              >隐藏</el-button
            >
            <el-button v-if="!isChangeText" class="excellent-form-btn" @click.prevent="changeText()"
              >显示</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handleCompute()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        method: '',
        chain_id: '',
        pri_key: '',
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID)
      },
      editRules: {
        method: [{ required: true, message: '请输入选择加密方式', trigger: 'blur' }],
        pri_key: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      options: [
        {
          label: '两个密文相加',
          value: 1
        },
        {
          label: '密文加明文',
          value: 2
        },
        {
          label: '密文减密文',
          value: 3
        },
        {
          label: '密文减明文',
          value: 4
        },
        {
          label: '密文乘以明文',
          value: 5
        }
      ],
      isChangeText: false,
      proclaimedTextDecryption: '', //显示文本
      proclaimedText: '', //后台返回后文本
      proclaimedTextEncryption: '', //加密
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.formDate.chain_id = val
      }
    }
  },
  mounted() {
    this.formDate.chain_id = this.$store.state.computing.chainId
    this.formDate.method = parseInt(localStorage.getItem('method')) || null // 设置初始值
  },
  methods: {
    handleCompute() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.formDate.pri_key = this.formDate.pri_key.replace(/\s/g, '')
          this.$apis.encryption.queryResult(this.formDate).then(res => {
            if (res) {
              this.proclaimedTextEncryption = '********'
              this.proclaimedText = res.data
              this.isChangeText = false
              this.$message.success('解密成功!')
            }
          })
        }
      })
    },
    changeText() {
      this.isChangeText = !this.isChangeText

      this.isChangeText
        ? (this.proclaimedTextEncryption = this.proclaimedText)
        : (this.proclaimedTextEncryption = '********')
    },
    methodChange(val) {
      localStorage.setItem('method', val)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.chainDecrypt-wrapper {
  @include adaptation(
    (
      --common-gap-16: 16px
    )
  );
  /deep/ .el-form-item__content {
    display: flex;

    :not(:first-child) {
      margin-left: var(--common-gap-16);
    }
  }

  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
